import {
    PROJECTS_PROFILE_REQUEST,
    PROJECTS_PROFILE_FAIL,
    PROJECTS_PROFILE_SUCCESS
} from "../../types"

const initialState = {
    isLoading: false,
    message: '',
    projects: {}
}

export const projectsReducer = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case PROJECTS_PROFILE_REQUEST:
            return {
                ...state,
                isLoading: false
            };
        case PROJECTS_PROFILE_SUCCESS:
            return {
                ...state,
                projects: payload,
                isLoading: true
            };
        case PROJECTS_PROFILE_FAIL:
            return {
                ...state,
                message: payload,
                isLoading: false
            };
        default:
            return state;
    }
}